import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a0cf715"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Cofres", -1))
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Criar novo cofre", -1))
const _hoisted_5 = { class: "header-action" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" CRIAR ")
const _hoisted_7 = { class: "form-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selecionar usuários", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Renomear cofre", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar sub cofre", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Excluir cofre", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_UserAddOutlined = _resolveComponent("UserAddOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_PlusSquareOutlined = _resolveComponent("PlusSquareOutlined")!
  const _component_question_circle_outlined = _resolveComponent("question-circle-outlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_input, {
          title: "cofre",
          value: _ctx.formCreateVault.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formCreateVault.name) = $event)),
          placeholder: "Cofre",
          maxlength: _ctx.lengthTitle + 1,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validTitle(_ctx.formCreateVault.name)))
        }, null, 8, ["value", "maxlength"]),
        _createVNode(_component_a_button, {
          type: "primary",
          loading: _ctx.loading,
          class: "btn-add-user",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createVault())),
          disabled: !_ctx.checkIsTitleEmpty(_ctx.formCreateVault.name) || _ctx.formCreateVault.name.length > _ctx.lengthTitle
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    _createVNode(_component_a_divider),
    _createElementVNode("section", _hoisted_7, [
      _createVNode(_component_a_table, {
        size: "small",
        columns: _ctx.columns,
        "data-source": _ctx.getFolders,
        "row-key": (record) => record.id,
        pagination: false,
        scroll: { y: 580 },
        onResizeColumn: _ctx.handleResizeColumn,
        class: "custom-table"
      }, {
        name: _withCtx(({ text }) => [
          _createElementVNode("span", null, [
            _createVNode(_component_LockOutlined),
            _createTextVNode(" " + _toDisplayString(text), 1)
          ])
        ]),
        users: _withCtx(({ record }) => [
          _createElementVNode("span", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.users, (tag) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: tag.id,
                color: "geekblue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.userName), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        action: _withCtx(({ record }) => [
          _createVNode(_component_a_space, { style: {"display":"flex","flex-direction":"row","align-items":"center","justify-content":"flex-end"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tooltip, null, {
                title: _withCtx(() => [
                  _hoisted_8
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    shape: "circle",
                    size: "small",
                    onClick: () => _ctx.openAddRemoveUsers(record)
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_UserAddOutlined)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_tooltip, null, {
                title: _withCtx(() => [
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    shape: "circle",
                    size: "small",
                    onClick: () => _ctx.openEditVault(record)
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_EditOutlined)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024),
              (record.parentId === null)
                ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                    title: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        shape: "circle",
                        size: "small",
                        onClick: () => _ctx.openAddChildrenVault(record)
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_PlusSquareOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_a_popconfirm, {
                placement: "left",
                title: "Deseja excluir o cofre? A exclusão implica em excluir o cofre e todo seu conteúdo",
                onConfirm: ($event: any) => (_ctx.remove(record)),
                cancelText: "Voltar",
                okText: "Confirmar"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_question_circle_outlined, { style: {"color":"red"} })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _hoisted_11
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "danger",
                        shape: "circle",
                        size: "small"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_DeleteOutlined)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "row-key", "onResizeColumn"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.open,
        title: _ctx.titleModal() ,
        onOk: _ctx.handleOk,
        closable: false
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            key: "back",
            onClick: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: _ctx.loading,
            onClick: _ctx.handleOk,
            disabled: ((!_ctx.checkIsTitleEmpty(_ctx.editFolder.name) || _ctx.editFolder.name.length > _ctx.lengthTitle) && _ctx.option == 2) || ((!_ctx.checkIsTitleEmpty(_ctx.formCreateChildrenVault.name) || _ctx.formCreateChildrenVault.name.length > _ctx.lengthTitle) && _ctx.option == 3)
          }, {
            default: _withCtx(() => [
              (_ctx.option === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Adicionar"))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "Salvar"))
            ]),
            _: 1
          }, 8, ["loading", "onClick", "disabled"])
        ]),
        default: _withCtx(() => [
          (_ctx.option == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_a_select, {
                  value: _ctx.addUserInVault.userIds,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addUserInVault.userIds) = $event)),
                  mode: "multiple",
                  style: {"width":"100%"},
                  placeholder: "Please select",
                  options: _ctx.users
                }, null, 8, ["value", "options"])
              ]))
            : (_ctx.option == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_a_input, {
                    title: "cofre",
                    value: _ctx.editFolder.name,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editFolder.name) = $event)),
                    placeholder: "Cofre",
                    maxlength: _ctx.lengthTitle + 1,
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validTitle(_ctx.editFolder.name)))
                  }, null, 8, ["value", "maxlength"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_a_input, {
                    title: "Sub Cofre",
                    value: _ctx.formCreateChildrenVault.name,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formCreateChildrenVault.name) = $event)),
                    placeholder: "Sub Cofre",
                    maxlength: _ctx.lengthTitle + 1,
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validTitle(_ctx.formCreateChildrenVault.name)))
                  }, null, 8, ["value", "maxlength"])
                ]))
        ]),
        _: 1
      }, 8, ["visible", "title", "onOk"])
    ])
  ]))
}